export default function getMenu(menu, roles) {
  if (roles.length === 0) return menu;

  const rolesSet = new Set(roles);

  return menu.reduce((acc, item) => {
    if (item.access?.some((role) => rolesSet.has(role) || role === "*")) {
      if (Array.isArray(item.route)) {
        const filteredRoutes = item.route.filter((r) =>
          r.access?.some((role) => rolesSet.has(role) || role === "*")
        );
        if (filteredRoutes.length > 0) {
          acc.push({ ...item, route: filteredRoutes });
        }
      } else {
        acc.push({ ...item });
      }
    }
    return acc;
  }, []);
}
